import { Card, Skeleton } from "@/components/ui";

export function PostCardSkeleton({ variant = "text" }: { variant?: "text" | "media" }) {
  return (
    <article>
      <Card className="space-y-3">
        <div className="flex items-center gap-3">
          <Skeleton className="size-8 rounded-full" />
          <div className="space-y-1">
            <Skeleton className="h-3 w-32" />
            <Skeleton className="h-3 w-20" />
          </div>
        </div>
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-4/5" />
        {variant === "media" && <Skeleton className="aspect-16/9 w-full rounded-sm" />}
        <div className="flex gap-4">
          <Skeleton className="h-4 w-12" />
          <Skeleton className="h-4 w-12" />
          <Skeleton className="h-4 w-12" />
        </div>
      </Card>
    </article>
  );
}
